import { render, staticRenderFns } from "./RiskCategoryAdd.vue?vue&type=template&id=78862f8c&"
import script from "./RiskCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./RiskCategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./RiskCategoryAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports